import RejectVerifyForm from './RejectVerifyForm';

export default RejectVerifyForm;
